import DataConst from 'consts/DataConst';

export default {
  name: DataConst.MODELS.CUSTOMER,
  primaryKey: 'id',
  properties: {
    id: 'int',
    name: 'string',
    phone: 'string?',
    address: 'string?',
    email: 'string?',
    note: 'string?',
    icon: 'string?',
    orders: 'Order[]',
    createdAt: 'date',
    updatedAt: 'date?'
  }
};
